<div class="flex flex-col items-start gap-4">
  <a
    routerLink="/cupons"
    routerLinkActive
    [routerLinkActiveOptions]="{ exact: true }"
    #rlaMob1="routerLinkActive"
    [ngClass]="rlaMob1.isActive ? 'text-primary-500 bg-white' : 'text-white'"
    class="rounded-md px-3 py-2 text-base"
    aria-current="page"
    >Cupons</a
  >
  <a
    routerLink="/delivery"
    routerLinkActive
    [routerLinkActiveOptions]="{ exact: true }"
    #rla2="routerLinkActive"
    [ngClass]="
      rla2.isActive
        ? 'text-secondary-600 bg-secondary-600'
        : 'text-slate-800 hover:bg-secondary-600 '
    "
    class="rounded-md px-2 py-2 text-base italic flex items-center text-white"
    aria-current="page"
    >Delivery
    <span
      class="text-xs bg-error-500 text-white rounded-3xl px-1 flex w-min h-min ml-2"
      >novo</span
    ></a
  >
  <a
    routerLink="/restaurantes"
    routerLinkActive
    [routerLinkActiveOptions]="{ exact: true }"
    #rlaMob3="routerLinkActive"
    [ngClass]="rlaMob3.isActive ? 'text-primary-500 bg-white' : 'text-white'"
    class="rounded-md px-3 py-2 text-base"
    >Restaurantes</a
  >
  <a
    routerLink="/baixe-o-app"
    routerLinkActive
    [routerLinkActiveOptions]="{ exact: true }"
    #rlaMob4="routerLinkActive"
    [ngClass]="rlaMob4.isActive ? 'text-primary-500 bg-white' : 'text-white'"
    class="rounded-md px-3 py-2 text-base"
    >Baixe o APP</a
  >
  <a
    routerLink="/planos"
    routerLinkActive
    [routerLinkActiveOptions]="{ exact: true }"
    #rlaMob5="routerLinkActive"
    [ngClass]="rlaMob5.isActive ? 'text-primary-500 bg-white' : 'text-white'"
    class="rounded-md px-3 py-2 text-base"
    >Parceiro Mobo</a
  >
  <a
    href="https://backoffice.mobo.com.br/"
    target="_blank"
    rel="noopener noreferrer"
    class="rounded-md px-3 py-2 text-base text-white ring-2 ring-white"
    >Painel do Restaurante</a
  >
</div>
